import { render, staticRenderFns } from "./StudiosGridChip.vue?vue&type=template&id=2cdb987c&scoped=true"
import script from "./StudiosGridChip.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudiosGridChip.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudiosGridChip.vue?vue&type=style&index=0&id=2cdb987c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdb987c",
  null
  
)

export default component.exports